<template>
  <v-dialog :value="switchUserModal" @input="updateModal" width="500px">
    <v-card>
      <v-card-text>
        <single-select-search v-model="switchTo" :options="users" keypath="aoid"
                              labelpath="name"/>
        <v-btn color="success" @click="switchUser">Switch user</v-btn>
        <v-btn @click="clearAuth">Clear authentication</v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex';
  import SingleSelectSearch from '@/views/shared/SingleSelectSearch';

  export default {
    components: { SingleSelectSearch },
    data() {
      return {
        switchTo: null
      };
    },
    computed: {
      ...mapState('auth', [
        'switchUserModal'
      ]),
      ...mapState('users', [
        'users'
      ])
    },
    methods: {
      switchUser() {
        if (this.switchTo) {
          this.$services.authenticator.post(`/switchuser?userId=${this.switchTo}`)
            .then((response) => {
              localStorage.setItem('accessToken', response.data.data.accessToken);
              localStorage.setItem('refreshToken', response.data.data.refreshToken);
              window.history.go(0);
            }).catch(this.$defaultHandlerHttp);
        }
      },
      clearAuth() {
        this.$auth._clearTokens();
        window.history.go(0);
      },
      ...mapActions('users', [
        'initialize'
      ]),
      ...mapMutations('auth', {
        updateModal: 'switchUserModal'
      })
    },
    mounted() {
      this.initialize()
        .catch(console.log); /* eslint-disable-line no-console */
    }
  };
</script>

<style scoped>

</style>
